import styled, { css } from 'styled-components';

export const CampaignNamesWrapper = styled.ul(
  ({ theme: { spacers, admanColors } }) => css`
    padding-left: ${spacers!.spacer04};
    margin: 0;
    max-width: 500px;
    max-height: 200px;
    overflow: auto;
    background-color: ${admanColors!.gray.dark.bg3[1]};
  `
);

export const CampaignName = styled.li`
  font-size: 12px;
  line-height: 18px;
`;
